package ai.wagemix.di

import ai.wagemix.analytics.WMSiteAnalytics
import ai.wagemix.data.WMAuthSyncDataSource
import ai.wagemix.data.WMBillingSyncDataSource
import ai.wagemix.data.WMCache
import ai.wagemix.data.WMJobDescriptionSyncDataSource
import ai.wagemix.data.WMLocalContextDataSource
import ai.wagemix.data.WMMixSyncDataSource
import ai.wagemix.data.WMStatsSyncDataSource
import ai.wagemix.data.firebase.WMFirebaseAuthSyncDataSource
import ai.wagemix.data.firebase.WMFirebaseAuthorizedRequester
import ai.wagemix.data.firebase.WMFirebaseMixSyncDataSource
import ai.wagemix.env
import ai.wagemix.logic.WMDataGateway
import ai.wagemix.logic.WMNavigationRequest
import ai.wagemix.logic.account.WMAccountDataGateway
import ai.wagemix.logic.account.WMAccountPresenter
import ai.wagemix.logic.account.WMDefaultAccountPresenter
import ai.wagemix.logic.account.createDefault
import ai.wagemix.logic.appshell.WMAppShellDataGateway
import ai.wagemix.logic.appshell.WMAppShellPresenter
import ai.wagemix.logic.appshell.WMDefaultAppShellPresenter
import ai.wagemix.logic.appshell.createDefault
import ai.wagemix.logic.auth.WMAuthDataGateway
import ai.wagemix.logic.auth.WMAuthPresenter
import ai.wagemix.logic.auth.WMDefaultAuthPresenter
import ai.wagemix.logic.auth.createDefault
import ai.wagemix.logic.picker.WMDefaultOccupationPickerPresenter
import ai.wagemix.logic.picker.WMOccupationPickerDataGateway
import ai.wagemix.logic.picker.WMOccupationPickerPresenter
import ai.wagemix.logic.picker.createDefault
import ai.wagemix.logic.jobdescriptions.WMDefaultJobDescriptionsPresenter
import ai.wagemix.logic.jobdescriptions.WMJobDescriptionsDataGateway
import ai.wagemix.logic.jobdescriptions.WMJobDescriptionsPresenter
import ai.wagemix.logic.jobdescriptions.createDefault
import ai.wagemix.logic.marketing.WMDefaultMarketingChromePresenter
import ai.wagemix.logic.marketing.WMMarketingChromeDataGateway
import ai.wagemix.logic.marketing.WMMarketingChromePresenter
import ai.wagemix.logic.marketing.createDefault
import ai.wagemix.logic.mixbuilder.WMDefaultMixBuilderPresenter
import ai.wagemix.logic.mixbuilder.WMMixBuilderDataGateway
import ai.wagemix.logic.mixbuilder.WMMixBuilderPresenter
import ai.wagemix.logic.mixbuilder.createDefault
import ai.wagemix.logic.mixes.WMDefaultSavedMixesPresenter
import ai.wagemix.logic.mixes.WMSavedMixesDataGateway
import ai.wagemix.logic.mixes.WMSavedMixesPresenter
import ai.wagemix.logic.sharedlinks.WMDefaultSharedLinksPresenter
import ai.wagemix.logic.sharedlinks.WMSharedLinksDataGateway
import ai.wagemix.logic.sharedlinks.WMSharedLinksPresenter
import ai.wagemix.logic.sharedlinks.createDefault
import ai.wagemix.logic.mixes.createDefault
import ai.wagemix.logic.payment.WMDefaultPaymentResultPresenter
import ai.wagemix.logic.payment.WMPaymentResultDataGateway
import ai.wagemix.logic.payment.WMPaymentResultPresenter
import ai.wagemix.logic.payment.createDefault
import ai.wagemix.logic.pricing.WMDefaultPricingPresenter
import ai.wagemix.logic.pricing.WMPricingDataGateway
import ai.wagemix.logic.pricing.WMPricingPresenter
import ai.wagemix.logic.pricing.createDefault
import ai.wagemix.logic.share.WMDefaultShareMixPresenter
import ai.wagemix.logic.share.WMShareMixDataGateway
import ai.wagemix.logic.share.WMShareMixPresenter
import ai.wagemix.logic.share.createDefault
import ai.wagemix.logic.sharedmix.WMDefaultSharedMixPresenter
import ai.wagemix.logic.sharedmix.WMSharedMixDataGateway
import ai.wagemix.logic.sharedmix.WMSharedMixPresenter
import ai.wagemix.logic.sharedmix.createDefault
import ai.wagemix.net.client.WagemixClientAPI
import ai.wagemix.net.models.configureWagemix
import ai.wagemix.web.screens.account.createDefaultAccountWebViewModel
import ai.wagemix.web.screens.appshell.createDefaultAppShellWebViewModel
import ai.wagemix.web.screens.auth.createDefaultAuthWebViewModel
import ai.wagemix.web.screens.picker.createDefaultOccupationPickerWebViewModel
import ai.wagemix.web.screens.jobdescriptions.createDefaultJobDescriptionsWebViewModel
import ai.wagemix.web.screens.marketing.createDefaultMarketingChromeWebViewModel
import ai.wagemix.web.screens.mixbuilder.createDefaultMixBuilderWebViewModel
import ai.wagemix.web.screens.mixes.createDefaultSavedMixesWebViewModel
import ai.wagemix.web.screens.sharedlinks.createDefaultSharedLinksWebViewModel
import ai.wagemix.web.screens.payment.createDefaultPaymentResultWebViewModel
import ai.wagemix.web.screens.pricing.createDefaultPricingWebViewModel
import ai.wagemix.web.screens.share.createDefaultShareMixWebViewModel
import ai.wagemix.web.screens.sharedmix.createDefaultSharedMixWebViewModel
import com.fsryan.foundation.data.FSLocalContextDataSource
import com.fsryan.foundation.net.client.FSAuthorizedRequester
import com.fsryan.foundation.net.client.ktor.createHttpClient
import com.russhwolf.settings.Settings
import com.russhwolf.settings.StorageSettings
import com.varabyte.kobweb.core.AppGlobals
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.FirebaseApp
import dev.gitlive.firebase.FirebaseOptions
import dev.gitlive.firebase.auth.FirebaseAuth
import dev.gitlive.firebase.auth.auth
import dev.gitlive.firebase.firestore.FirebaseFirestore
import dev.gitlive.firebase.firestore.firestore
import dev.gitlive.firebase.initialize
import io.ktor.client.plugins.sse.SSE
import org.koin.core.context.GlobalContext
import org.koin.core.context.startKoin
import org.koin.core.parameter.parametersOf
import org.koin.core.qualifier.named
import org.koin.dsl.module

/*
 * The one object graph of the site. Koin is an application-level dependency: no library module
 * below `site` declares bindings, every type is bound here against its interface through its fake
 * constructor (public-API-shape playbook), and the per-presenter gateways resolve to the one
 * aggregate (data-gateway playbook, Step 5).
 */

private const val API_BASE_URL = "ai.wagemix.API_BASE_URL"

/** The Firebase project for the environment the site was built for. */
private fun firebaseOptions(siteEnv: String): FirebaseOptions = when (siteEnv) {
    "prod" -> FirebaseOptions(
        apiKey = "AIzaSyDTb-WfZ8qA6FGUV8urjmkyP6W5VfPsMAs",
        authDomain = "wagemix.firebaseapp.com",
        projectId = "wagemix",
        storageBucket = "wagemix.firebasestorage.app",
        gcmSenderId = "778714194545",
        applicationId = "1:778714194545:web:ac2795da6a882b534131d0",
        gaTrackingId = "G-M50E2V899Y"
    )
    "staging", "dev" -> FirebaseOptions(
        apiKey = "AIzaSyAfkO6mfdgC4OA5s5LRWDkKfegujxCoT5k",
        authDomain = "wagemix-staging.firebaseapp.com",
        projectId = "wagemix-staging",
        storageBucket = "wagemix-staging.firebasestorage.app",
        gcmSenderId = "899621875222",
        applicationId = "1:899621875222:web:a38b85b16224eb04334f37"
    )
    else -> error("Unknown SITE_ENV: $siteEnv")
}

/** The process singletons: the one local context, the settings store, the HTTP client and the Firebase SDK handles. */
private val platformModule = module {
    single<FSLocalContextDataSource> { FSLocalContextDataSource() }
    single<Settings> { StorageSettings() }
    single(named(API_BASE_URL)) { AppGlobals.getValue("API_URL") }
    // The signed-in Firebase user's id token is the bearer token of every authenticated API call.
    single<FSAuthorizedRequester> { WMFirebaseAuthorizedRequester(auth = get(), apiBaseUrl = get(named(API_BASE_URL))) }
    single<WagemixClientAPI> {
        val httpClient = createHttpClient(
            appName = "wagemix-web",
            appVersion = "0.0.1",
            appVersionCode = 1,
            verbose = AppGlobals.env() != "prod",
            configureJson = { configureWagemix() }
        ).config { install(SSE) }
        WagemixClientAPI(httpClient, baseUrl = get(named(API_BASE_URL)), authorizedRequester = get())
    }
    single<FirebaseApp> { Firebase.initialize(options = firebaseOptions(AppGlobals.env())) }
    single<FirebaseAuth> { Firebase.auth(get<FirebaseApp>()) }
    single<FirebaseFirestore> { Firebase.firestore(get<FirebaseApp>()) }
}

/** The data layer: local stores and the sync data sources, the Firebase-backed ones from the variant module. */
private val dataModule = module {
    single<WMLocalContextDataSource> { WMLocalContextDataSource(localContextDataSource = get()) }
    single<WMCache> { WMCache(settings = get()) }
    single<WMStatsSyncDataSource> { WMStatsSyncDataSource(api = get(), cache = get(), localContext = get()) }
    single<WMJobDescriptionSyncDataSource> { WMJobDescriptionSyncDataSource(api = get(), localContext = get()) }
    single<WMBillingSyncDataSource> { WMBillingSyncDataSource(api = get(), localContext = get()) }
    // The Firebase-backed sources begin mirroring the signed-in user into the cache and local context when created.
    single<WMMixSyncDataSource>(createdAtStart = true) {
        WMFirebaseMixSyncDataSource(auth = get(), firestore = get(), api = get(), localContext = get())
    }
    single<WMAuthSyncDataSource>(createdAtStart = true) {
        WMFirebaseAuthSyncDataSource(auth = get(), firestore = get(), clientAPI = get(), cache = get(), localContext = get())
    }
}

/** The logic layer: the one aggregate gateway, every per-presenter gateway bound to it, and a factory per presenter. */
private val logicModule = module {
    single<WMDataGateway> {
        WMDataGateway(
            localContext = get(),
            cache = get(),
            statsSync = get(),
            jobDescriptionSync = get(),
            mixSync = get(),
            billingSync = get(),
            authSync = get()
        )
    }
    factory<WMAppShellDataGateway> { get<WMDataGateway>() }
    factory<WMMixBuilderDataGateway> { get<WMDataGateway>() }
    factory<WMOccupationPickerDataGateway> { get<WMDataGateway>() }
    factory<WMSavedMixesDataGateway> { get<WMDataGateway>() }
    factory<WMSharedLinksDataGateway> { get<WMDataGateway>() }
    factory<WMJobDescriptionsDataGateway> { get<WMDataGateway>() }
    factory<WMShareMixDataGateway> { get<WMDataGateway>() }
    factory<WMAccountDataGateway> { get<WMDataGateway>() }
    factory<WMPricingDataGateway> { get<WMDataGateway>() }
    factory<WMPaymentResultDataGateway> { get<WMDataGateway>() }
    factory<WMAuthDataGateway> { get<WMDataGateway>() }
    factory<WMSharedMixDataGateway> { get<WMDataGateway>() }
    factory<WMMarketingChromeDataGateway> { get<WMDataGateway>() }

    // Presenters that take route parameters receive them through parametersOf(...) in declaration
    // order; an optional id travels as "" because Koin parameters are non-null.
    factory<WMDefaultAppShellPresenter> { WMAppShellPresenter.createDefault(dataGateway = get()) }
    factory<WMDefaultMarketingChromePresenter> { (leaveWhenSignedIn: Boolean) ->
        WMMarketingChromePresenter.createDefault(leaveWhenSignedIn = leaveWhenSignedIn, dataGateway = get())
    }
    factory<WMDefaultMixBuilderPresenter> { (mixId: String) -> WMMixBuilderPresenter.createDefault(mixId = mixId.ifEmpty { null }, dataGateway = get()) }
    factory<WMDefaultOccupationPickerPresenter> { WMOccupationPickerPresenter.createDefault(dataGateway = get()) }
    factory<WMDefaultSavedMixesPresenter> { WMSavedMixesPresenter.createDefault(dataGateway = get()) }
    factory<WMDefaultSharedLinksPresenter> { WMSharedLinksPresenter.createDefault(dataGateway = get()) }
    factory<WMDefaultJobDescriptionsPresenter> { WMJobDescriptionsPresenter.createDefault(dataGateway = get()) }
    factory<WMDefaultShareMixPresenter> { (mixId: String) -> WMShareMixPresenter.createDefault(mixId = mixId, dataGateway = get()) }
    factory<WMDefaultAccountPresenter> { WMAccountPresenter.createDefault(dataGateway = get()) }
    factory<WMDefaultPricingPresenter> {
        WMPricingPresenter.createDefault(dataGateway = get())
    }
    factory<WMDefaultPaymentResultPresenter> { (sessionId: String) ->
        WMPaymentResultPresenter.createDefault(sessionId = sessionId.ifEmpty { null }, dataGateway = get())
    }
    factory<WMDefaultAuthPresenter> { (workflow: String, nextRoute: String) ->
        WMAuthPresenter.createDefault(workflow = workflow, nextRoute = nextRoute.ifEmpty { null }, dataGateway = get())
    }
    factory<WMDefaultSharedMixPresenter> { (sharedMixId: String) ->
        WMSharedMixPresenter.createDefault(sharedMixId = sharedMixId.ifEmpty { null }, dataGateway = get())
    }
}

/**
 * The web layer: view-model factories, one per screen. There is no androidx `viewModel` on the
 * web; the page's `FSWebScreen` factory lambda resolves one of these with `parametersOf(...)`
 * (route parameters first, then the navigation callback).
 */
private val webModule = module {
    factory { (nav: (WMNavigationRequest) -> Unit) -> createDefaultAppShellWebViewModel(presenter = get(), externalNavigation = nav) }
    factory { (leaveWhenSignedIn: Boolean, nav: (WMNavigationRequest) -> Unit) ->
        createDefaultMarketingChromeWebViewModel(presenter = get { parametersOf(leaveWhenSignedIn) }, externalNavigation = nav)
    }
    factory { (mixId: String, nav: (WMNavigationRequest) -> Unit, onShare: (String) -> Unit) ->
        createDefaultMixBuilderWebViewModel(presenter = get { parametersOf(mixId) }, externalNavigation = nav, onShareRequest = onShare)
    }
    factory { (onDone: () -> Unit) -> createDefaultOccupationPickerWebViewModel(presenter = get(), onDone = onDone) }
    factory { (nav: (WMNavigationRequest) -> Unit, onShare: (String) -> Unit) ->
        createDefaultSavedMixesWebViewModel(presenter = get(), externalNavigation = nav, onShareRequest = onShare)
    }
    factory { (nav: (WMNavigationRequest) -> Unit) -> createDefaultJobDescriptionsWebViewModel(presenter = get(), externalNavigation = nav) }
    factory { createDefaultSharedLinksWebViewModel(presenter = get()) }
    factory { (mixId: String, nav: (WMNavigationRequest) -> Unit) ->
        createDefaultShareMixWebViewModel(presenter = get { parametersOf(mixId) }, externalNavigation = nav)
    }
    factory { (nav: (WMNavigationRequest) -> Unit) -> createDefaultAccountWebViewModel(presenter = get(), externalNavigation = nav) }
    factory { (nav: (WMNavigationRequest) -> Unit) ->
        createDefaultPricingWebViewModel(presenter = get(), externalNavigation = nav)
    }
    factory { (sessionId: String) -> createDefaultPaymentResultWebViewModel(presenter = get { parametersOf(sessionId) }) }
    factory { (workflow: String, nextRoute: String, nav: (WMNavigationRequest) -> Unit) ->
        createDefaultAuthWebViewModel(presenter = get { parametersOf(workflow, nextRoute) }, externalNavigation = nav)
    }
    factory { (sharedMixId: String) -> createDefaultSharedMixWebViewModel(presenter = get { parametersOf(sharedMixId) }) }
}

/** Starts the object graph once per page load; the eagerly created sync data sources start their mirrors. */
fun initKoin() {
    if (GlobalContext.getOrNull() != null) {
        return
    }
    startKoin {
        modules(platformModule, dataModule, logicModule, webModule)
    }
    // The analytics writer was installed by @InitKobweb; its session and profile observers need the gateway.
    WMSiteAnalytics.startObserving(dataGateway = GlobalContext.get().get())
}

/** The one Koin for the page; pages resolve presenters and view models through it. */
val koin get() = GlobalContext.get()
